module.exports = __webpack_public_path__ + "static/media/image-card-1.530b6ff1.png";